import { v4 as uuidv4 } from 'uuid';

import { StorageKeys } from '../../common/constants';
import storage from '../../common/providers/StorageFacade';
import { captureWarning } from '../../logger/Logger';

let inMemoryVisitorId: string | null = null;

export const getStoredVisitorId = (): string | null => {
    try {
        const existingVisitorId = storage.getString(StorageKeys.VISITOR_ID);
        if (existingVisitorId != null && existingVisitorId !== '') {
            return existingVisitorId;
        }
    } catch (error) {
        captureWarning('Unable to read visitor ID from storage', error);
    }

    return null;
};

const storeVisitorId = (id: string): void => {
    try {
        storage.setString(StorageKeys.VISITOR_ID, id);
    } catch (error) {
        captureWarning('Unable to persist visitor ID to storage', error);
    }
};

export const visitorId = (): string => {
    const storedVisitorId = getStoredVisitorId();
    if (storedVisitorId != null) {
        inMemoryVisitorId = storedVisitorId;
        return storedVisitorId;
    }

    if (inMemoryVisitorId != null) {
        return inMemoryVisitorId;
    }

    const id = uuidv4();
    inMemoryVisitorId = id;
    storeVisitorId(id);
    return id;
};
